import { render, staticRenderFns } from "./startAhued.vue?vue&type=template&id=5d218f4b&"
import script from "./startAhued.vue?vue&type=script&lang=js&"
export * from "./startAhued.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports